import { createContext, ReactNode, useContext } from "react";

const PermissionContext = createContext<ReadonlySet<string>>(new Set());

export function ConsolePermissionProvider({ permissions, children }: { permissions: string[]; children: ReactNode }) {
  return <PermissionContext.Provider value={new Set(permissions)}>{children}</PermissionContext.Provider>;
}

export function useConsolePermissions() {
  const permissions = useContext(PermissionContext);
  return {
    has: (permission: string) => permissions.has(permission),
    any: (...required: string[]) => required.some((permission) => permissions.has(permission))
  };
}
